import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomImageAvatar from "../Avatar/main";
import { SingleListAvatarShimmer } from "../../molecules/shimmer/List/main";
import { useSelector } from "react-redux";
import { stateType } from "../../../store/store.type";
import { useState } from "react";
type CustomAccordianWithAvatarType = {
  avatarSource: string;
  title: string;
  subtitle: string;
  altText: string;
  expanded?: boolean;
  children: React.ReactNode;
};
const CustomAccordianWithAvatar = ({
  avatarSource,
  title,
  subtitle,
  altText,
  expanded,
  children,
}: CustomAccordianWithAvatarType) => {
  const sidePanelOpen = useSelector(
    (sel: stateType) => sel.panelSlice.panelOpen,
  );
  const [isAccordianOpen, setAccordian] = useState(false);
  return (
    <Accordion
      elevation={0}
      sx={{
        margin: "-12px 0px 0px 0px",
        "&.Mui-expanded": {},
      }}
      onChange={() => {
        setAccordian((p) => !p);
      }}
      expanded={sidePanelOpen && isAccordianOpen}
    >
      <AccordionSummary
        expandIcon={expanded ? <ExpandMoreIcon /> : null}
        aria-controls="panel1a-content"
        id="panel1a-header"
        disabled={!expanded}
        sx={{
          "&.Mui-disabled": {
            backgroundColor: "white",
            opacity: 1,
          },
          "&.Mui-expanded": {
            margin: !expanded ? "0px" : "",
          },
        }}
      >
        {title === "" ? (
          <SingleListAvatarShimmer avatarVarient="circular" />
        ) : (
          <Box sx={{ display: "flex", gap: "12px" }}>
            <CustomImageAvatar altText={altText} avatarSource={avatarSource} />
            {expanded && (
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontSize: "0.875rem", fontWeight: 600 }}
                >
                  {title.length > 14 ? title.slice(0, 14) + ".." : title}
                </Typography>
                <Typography variant="subtitle2">
                  {subtitle.length > 12
                    ? subtitle.slice(0, 12) + ".."
                    : subtitle}
                </Typography>
              </Box>
            )}
          </Box>
        )}
      </AccordionSummary>
      <AccordionDetails>{expanded && children}</AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordianWithAvatar;
